export default {
	create: {
		successMessage: 'New attribute set has been created.',
	},
	delete: {
		successMessage: 'Remove attribute set success',
	},
};
